module.exports = __webpack_public_path__ + "static/media/2011 - 2012 theme logo.5a241727.jpg";